import React, { useEffect, useState } from "react";
import {
  GetRequest,
  PostRequest,
  PutRequest,
  DeleteRequest,
} from "../../repository/RequestMaker";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrashCan, faEdit } from "@fortawesome/free-solid-svg-icons";
import Modal from "react-modal";
import "./Companies.css";

Modal.setAppElement("#root");

export default function Companies() {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    domain: "",
    private_data: "no",
  });

  useEffect(() => {
    fetchCompanies();
  }, []);

  const fetchCompanies = () => {
    setLoading(true);
    GetRequest("/companies")
      .then((response) => {
        setCompanies(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Failed to fetch companies", error);
        setLoading(false);
      });
  };

  const formatDate = (dateString) => {
    return moment(dateString).format("YYYY-MM-DD HH:mm:ss");
  };

  const openModal = (company = null) => {
    if (company) {
      setFormData({
        id: company.id,
        name: company.name,
        domain: company.domain,
        private_data: company.private_data,
      });
      setIsEditMode(true);
    } else {
      setFormData({
        id: "",
        name: "",
        domain: "",
        private_data: "",
      });
      setIsEditMode(false);
    }
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const onDeleteClick = (id) => {
    setDeleteId(id);
    setDeleteModalIsOpen(true);
  };

  const handleDelete = () => {
    DeleteRequest(`/companies/${deleteId}`)
      .then(() => {
        fetchCompanies();
        closeDeleteModal();
      })
      .catch((error) => {
        console.error("Failed to delete company", error);
        closeDeleteModal();
      });
  };

  const closeDeleteModal = () => {
    setDeleteModalIsOpen(false);
    setDeleteId(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log(`Changing ${name} to ${value}`);
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const request = isEditMode
      ? PutRequest(formData, `/companies/${formData.id}`)
      : PostRequest(formData, "/companies");

    request
      .then(() => {
        fetchCompanies();
        closeModal();
      })
      .catch((error) => {
        console.error("Failed to submit form", error);
      });
  };

  return (
    <div className="companies-container">
      <div className="actions-header">
        <button className="btn-add" onClick={() => openModal()}>
          <FontAwesomeIcon icon={faPlus} /> Add New Company
        </button>
      </div>
      {loading ? (
        <p style={{ textAlign: "center" }}>Wird geladen...</p>
      ) : (
        <div className="card-admin animated fadeInDown">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Domain</th>
                <th>Private Daten</th>
                <th>Erstellungsdatum</th>
                <th>Bearbeitungsdatum</th>
                <th>Aktionen</th>
              </tr>
            </thead>
            <tbody>
              {companies.map((company) => (
                <tr key={company.id}>
                  <td>{company.id}</td>
                  <td>{company.name}</td>
                  <td>{company.domain}</td>
                  <td>{company.private_data}</td>
                  <td>{formatDate(company.created_at)}</td>
                  <td>{formatDate(company.updated_at)}</td>
                  <td>
                    <button
                      className="btn-edit"
                      onClick={() => openModal(company)}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                    &nbsp;
                    <button
                      className="btn-delete"
                      onClick={() => onDeleteClick(company.id)}
                    >
                      <FontAwesomeIcon icon={faTrashCan} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={{
          overlay: {
            zIndex: 9999,
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: "50%",
            maxHeight: "80%",
            overflow: "auto",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <h5>{isEditMode ? "Update Company" : "Add New Company"}</h5>
        <form onSubmit={handleFormSubmit} className="modal-form">
          <div className="form-group">
            <label>Name:</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
              className="form-control"
            />
          </div>
          <div className="form-group">
            <label>Domain:</label>
            <input
              type="text"
              name="domain"
              value={formData.domain}
              onChange={handleInputChange}
              required
              className="form-control"
            />
          </div>
          <div className="form-group">
            <label>Private Daten:</label>
            <select
              name="private_data"
              value={formData.private_data}
              onChange={handleInputChange}
              className="form-control"
            >
              <option value="">Select a value</option>
              <option value="yes" selected={formData.private_data === "yes"}>
                Yes
              </option>
              <option value="no" selected={formData.private_data === "no"}>
                No
              </option>
            </select>
          </div>
          <div style={{ paddingTop: "15px" }} className="modal-actions">
            <button type="submit" className="btn-submit">
              {isEditMode ? "Update" : "Add"}
            </button>
            <button type="button" className="btn-cancel" onClick={closeModal}>
              Cancel
            </button>
          </div>
        </form>
      </Modal>
      <Modal
        isOpen={deleteModalIsOpen}
        onRequestClose={closeDeleteModal}
        style={{
          overlay: {
            zIndex: 9999,
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: "50%",
            maxHeight: "80%",
            overflow: "auto",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <h5>Are you sure you want to delete this company?</h5>
        <div className="modal-actions">
          <button className="btn-delete" onClick={handleDelete}>
            Delete
          </button>
          <button className="btn-cancel" onClick={closeDeleteModal}>
            Cancel
          </button>
        </div>
      </Modal>
    </div>
  );
}
